"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// saving bytes by not having "object", "function", "undefined"
// defined in bundled code more than one time
exports.TYPE_OBJECT = "object";
//# sourceMappingURL=type-object.js.map